import Hero from "../components/Hero/Hero";
import About from "../components/About/About";
import Services from "../components/Services/Services";
import Steps from "../components/Steps/Steps";
import Footer from "../components/Footer/Footer";
import ContactForm from "../components/ContactForm/ContactForm";

function LandingMedical() {
  return (
    <>
      <Hero />
      <About />
      <Services />
      <Steps />
      <ContactForm />
      <Footer />
    </>
  );
}

export default LandingMedical;